import styled from 'styled-components';
import { ReactComponent as Close } from 'assets/icons/closeIcon.svg';

export const Wrapper = styled.div`
    background: white;
    width: 85vw;
    max-height: 755px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: 48px 24px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    max-width: 1096px;
    /* overflow-y: auto; */

    @media (max-width: 1280px) {
        max-height: 565px;
        padding: 70px 24px 24px;
    }
`;

export const PageWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    max-height: 680px;

    @media (max-width: 1280px) {
        max-height: 490px;
    }
`;

export const CloseIcon = styled(Close)`
    position: absolute;
    top: 11px;
    right: 19px;
    cursor: pointer;
`;

export const ImageWrapper = styled.div`
    max-height: 610px;
    width: 970px;

    & img {
        width: 100%;
        height: auto;
    }

    @media (max-width: 1280px) {
        max-height: 510px;
    }
`;

export const ContentWrapper = styled.div`
    width: 1048px;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    overflow-y: auto;
`;
